export default "__VITE_ASSET__DRK8xAQN__"